<template>
  <div>
    <template v-if="message.errorMessage != null">
      <div class="alert alert-danger alert-dismissible" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="message.errorMessage =null">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="success-message" v-html="$t(message.errorMessage)"></div>
      </div>
    </template>
    <form class="form-horizontal form-edit-account" :name="formName" @submit.prevent="saveAmsCustomerDetail()"
          novalidate>
      <div v-for="el in forceNewsInfo.blockOrder" class="form-group-sub sub-news" :key="el">
        <div>
          <component
              @onChangeChildFormStatus="handleChildFormStatus"
              @onChangeFileUpload="handleChangeFileUpload(el)"
              v-if="input !== null"
              :is="mapBlockTemplate[el].component"
              :requireCharacters="forceNewsInfo.mapUpdateBlock[el]"
              :inputProp="input"
              :ref="forceNewsInfo.messageId + '_' + el"
              :blockName="el"
              :displayForms="forceNewsInfo.displayForms"
          >
          </component>
          <div class="alert alert-success alert-dismissible" role="alert" v-if="mapMessage[el]">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="success-message" v-html="mapMessage[el]"></div>
          </div>
        </div>

      </div>
      <div class="form-action">
        <button class="btn btn-submit btn-success" v-if="!isExistForceUpdate && !isSubmitSuccess" type="submit">
          {{ forceNewsInfo.buttonAcceptText }}
        </button>
        <button id="forceOnSubmit" class="btn btn-submit btn-success" v-if="isExistForceUpdate && !isSubmitSuccess"
                :disabled="isDisabledButtonSubmit" type="submit">
          {{ forceNewsInfo.buttonAcceptText }}
        </button>
        <a class="btn btn-submit btn-success" v-if="isSubmitSuccess" @click="removeUpdatedNews">
          {{ $t('label.news.closeNews') }}
        </a>
        <a class="btn btn-submit btn-default btn-cancel" v-if="!isExistForceUpdate && !isSubmitSuccess"
           @click.prevent="skipCustomerNews">
          {{ forceNewsInfo.buttonCloseText }}
        </a>
      </div>
    </form>
  </div>
</template>

<script>
/**
 * @author HungNS
 */
import {createNamespacedHelpers} from 'vuex';
import _, {find, isEmpty, isNil} from 'lodash'
import $ from 'jquery';
import * as FORCE_NEWS_TYPE from "@/store/modules/force-news/type";
import * as NEWS_TYPE from "@/store/modules/news/type";
import {mapBlockTemplate} from "@/common/constants/enums";

const {mapState: mapForceNewsState, mapGetters: mapForceNewsGetters, mapActions: mapForceNewsActions} = createNamespacedHelpers("forceNews");
const {mapActions: mapNewsActions} = createNamespacedHelpers("news");



export default {
    name: "forceNewsForm",
    props: {
        forceNewsInfo: {
            type: Object,
        },
        messageId: {
            type: String
        }
    },
    provide() {
        return {
            messageId: this.messageId,
            forceNewsInfo: this.forceNewsInfo
        }
    },
    data() {
        const listChangeBlockInfo = [];
        const blocksInvalidStatus = {};
        let mapMessage = {};
        for (let key in this.forceNewsInfo.mapUpdateBlock) {
            listChangeBlockInfo.push(key);
            blocksInvalidStatus[key] = null;
            mapMessage[key] = null;
        }
        return {
            blocksInvalidStatus: blocksInvalidStatus,
            service: this.$service.getService('forceNews'),
            mapMessage,
            listChangeBlockInfo,
            message: {
                errorMessage: null,
                successMessage: null
            },
            processAction: false,
            processing: false,
            statusBlock: false,
            isSubmitSuccess: false,
            doesServerReturnError: false,
            mapBlockTemplate: mapBlockTemplate,
            isValid: false
        }
    },
    computed: {
        isExistForceUpdate() {
            const forceNewsInfo = this.forceNewsInfo;
            for (let key in forceNewsInfo.mapUpdateBlock) {
                if (forceNewsInfo.mapUpdateBlock[key] === true) {
                    return true;
                }
            }
            return false;
        },
        isDisabledButtonSubmit() {
            if (this.isExistForceUpdate && this.doesServerReturnError) {
                return true;
            }

            /* Value of blocksInvalidStatus
               - not inputting into force news block ( default value ) -> null
               - incorrectly inputting into force news block -> true
               - correctly inputting into force news block  -> false
               Just 1 input force on is entered, enable button submit
            */

            let mapUpdateBlockStatus = [];
            let status = [];
            let isValid = true;
            let isOn = false;
            let isForceOn = false;
            let block = Object.assign({}, this.forceNewsInfo.mapUpdateBlock);
            for (const [, value] of Object.entries(this.forceNewsInfo.mapUpdateBlock)) {
                mapUpdateBlockStatus.push(value);
            }

            mapUpdateBlockStatus.every(status => (status !== null && status === false)) ? isOn = true : isOn = false;

            mapUpdateBlockStatus.every(status => (status !== null && status === true)) ? isForceOn = true : isForceOn = false;

            for (const [key, value] of Object.entries(this.blocksInvalidStatus)) {
                if (this.forceNewsInfo.mapUpdateBlock[key]) {
                    status.push(value);
                    if (value !== null) {
                        block[key] = value;
                    }
                }
            }

            if (status.length > 0) {
                if (isOn) {
                    isValid = false;
                } else if (isForceOn) {
                    status.every(status => (status !== null && status === false)) ? isValid = false : isValid = true;
                } else {
                    // Case: type is: ON AND FORCE ON
                    if (JSON.stringify(block) !== JSON.stringify(this.forceNewsInfo.mapUpdateBlock)) {
                        isValid = false;
                    }
                }
            }

            return isValid;
        },
        ...mapForceNewsState({
            formName: (state) => state.formName,
            inputArr: (state) => state.inputArr,
            isCorporation: state => state.isCorporation,
            remainForceNewsList: state => state.remainForceNewsList,
            SUPPORT_DOCUMENT_URL: state => state.SUPPORT_DOCUMENT_URL,
            NEW_UPLOAD_DOCUMENT_URL: state => state.NEW_UPLOAD_DOCUMENT_URL
        }),
        input() {
            let result = null;
            if (!isEmpty(this.inputArr) && !isNil(this.inputArr)) {
                result = find(this.inputArr, (item) => {
                    return item.messageId == this.messageId;
                })
            }
            return result
        },
        ...mapForceNewsGetters(['mapGroupFieldAmsCustomer'])
    },
    methods: {
        ...mapForceNewsActions([FORCE_NEWS_TYPE.SET_REMAIN_FORCE_NEWS_LIST]),
        ...mapNewsActions([NEWS_TYPE.SET_FORCE_NEWS_FLG]),
        removeUpdatedNews() {
            const {remainForceNewsList} = this;
            const remainForceNewsListClone = [...remainForceNewsList];
            for (let i = remainForceNewsListClone.length - 1; i >= 0; i--) {
                if (remainForceNewsListClone[i] === this.forceNewsInfo.messageId) {
                    remainForceNewsListClone.splice(i, 1);
                }
            }
            this[FORCE_NEWS_TYPE.SET_REMAIN_FORCE_NEWS_LIST](remainForceNewsListClone);
            if (remainForceNewsListClone.length >= 1) {
                $("#" + this.forceNewsInfo.messageId).hide();
            } else {
                this.$router.push("/index");
            }
        },
        async skipCustomerNews() {
            if (this.isExistForceUpdate) {
                return;
            }
            const params = new FormData();
            params.append("messageId", this.forceNewsInfo.messageId);
            try {
                const response = await this.service.saveForceNews(params);
                const {data} = response;
                if (isEmpty(data.errorMessage)) {
                    this[NEWS_TYPE.SET_FORCE_NEWS_FLG](false);
                    this.$root.$emit(this.IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT);
                    this.removeUpdatedNews();
                } else {
                    this.message.errorMessage = data.errorMessage;
                }
            } catch (error) {
                this.processAction = false;
                this.message.errorMessage = "error.happen";
            }
        },
        async saveAmsCustomerDetail() {
            this.processAction = true;
            const fd = this.preparedDataInput();
            const validTotalBlock = await this.validTotalBlocks(fd);

            for (const [key, ] of Object.entries(this.blocksInvalidStatus)) {
              if (key === 'CUSTOMER_MAIN_MAIL' && !validTotalBlock) {
                 this.isValid = false;
                 break;
              }
            }

            if (validTotalBlock && !this.processing || this.isValid) {
                try {
                    const response = await this.service.updateCustomerInfo(fd);
                    const {data} = response;

                    // hot fix for axios Network Error, because it isn't caught by catch block
                    if (data && this.ServiceUtils.isAxiosNetworkError(data.message)) {
                        throw "Axios Network Error";
                    }

                    this.message.errorMessage = data.errorMessage;
                    if (data.result === this.IConstants.RESULT_AJAX.SUCCESS) {
                        this.$root.$emit(this.IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT); // Send CLOSE action to Bridge (using in webview of Crypto App (IOS, Android) only)
                        this.isSubmitSuccess = true;
                        this.message.successMessage = data.successMessage;
                        let successMessage = null;
                        for (let key in this.mapMessage) {
                            if (data.mapMessage[key] === 'profile.update.success.corp.change_name_address') {
                                successMessage = this.$t('profile.update.success.corp.change_name_address', {param1: this.SUPPORT_DOCUMENT_URL});
                            } else if (data.mapMessage[key] === 'profile.update.success.indv.change_name_address') {
                                successMessage = this.$t('profile.update.success.indv.change_name_address', {
                                    param1: this.NEW_UPLOAD_DOCUMENT_URL + "/home?source=czfx",
                                    param2: this.SUPPORT_DOCUMENT_URL
                                });
                            } else if (data.mapMessage[key] === 'profile.update.success.indv.change_name_address.uploadFile') {
                                successMessage = this.$t('profile.update.success.indv.change_name_address.uploadFile', {param1: this.SUPPORT_DOCUMENT_URL});
                            } else if (data.mapMessage[key] === 'profile.update.success.corp.change_name_address.uploadFile') {
                                successMessage = this.$t('profile.update.success.corp.change_name_address.uploadFile', {param1: this.SUPPORT_DOCUMENT_URL});
                            } else if (data.mapMessage[key] === 'profile.label.upload.mynumber.msg.success') {
                                successMessage = this.$t('profile.label.upload.mynumber.msg.success');
                            } else {
                                successMessage = data.mapMessage[key];
                            }
                            this.mapMessage[key] = this.$t(successMessage);
                        }
                        this.disableAllInput();
                        this[NEWS_TYPE.SET_FORCE_NEWS_FLG](false);
                    } else {
                        this.message.errorMessage = data.errorMessage;
                        this.doesServerReturnError = true;
                    }
                    this.processing = false;
                } catch (error) {
                    this.message.errorMessage = "profile.update.error.MSG_TRS_NAB_0010";
                } finally {
                    this.scrollToCurrentNews(this.forceNewsInfo.messageId);
                    this.processAction = false;
                }
            } else {
              const $error =await $('.error-messages,.ng-active').first();
              if ($error.closest('.col-md-6').find('input').length > 0) {
                $error.closest('.col-md-6').find('input').focus();
              } else {
                $([document.documentElement, document.body]).animate({scrollTop: $error.first().parent().offset().top - 200}, 1);
              }
            }
        },
        preparedDataInput() {
            let fd = new FormData();
            fd.append("listChangeBlockInfo", this.listChangeBlockInfo);
            const listFieldSubmit = [];

            for (let i = 0; i < this.listChangeBlockInfo.length; i++) {
                const listBlockField = this.mapGroupFieldAmsCustomer[this.listChangeBlockInfo[i]];
                for (let index = 0; index < listBlockField.length; index++) {
                    if (listFieldSubmit.indexOf(listBlockField[index]) == -1) {
                        listFieldSubmit.push(listBlockField[index]);
                    }
                }
            }
            for (let field in listFieldSubmit) {
                if (listFieldSubmit[field] == "investmentView" || listFieldSubmit[field] == "cryptInvestmentPurposeView" || listFieldSubmit[field] == "boInvestmentPurposeView") {
                    const nameField = listFieldSubmit[field];
                    for (let investmentField in this.input["amsCustomerDetail." + nameField]) {
                        fd.append("amsCustomerDetail." + nameField + "." + investmentField, this.input["amsCustomerDetail." + nameField][investmentField]);
                    }
                } else if (listFieldSubmit[field].indexOf("file") == 0) {

                    if (listFieldSubmit[field] == "fileCustomerAddress") {
                        const customerAddressRef = this.getRefFromComponent('CUSTOMER_ADDRESS');
                        const indexHasFile = [];
                        for (let i = 1; i < 4; i++) {
                            if (customerAddressRef[listFieldSubmit[field] + i] != null) {
                                indexHasFile.push(i);
                            }
                        }
                        for (let i = 0; i < indexHasFile.length; i++) {
                            const file = customerAddressRef[listFieldSubmit[field] + indexHasFile[i]];
                            fd.append("fileCustomerAddressUploades[" + i + "]", file);
                            fd.append("fileCustomerAddressFileNames[" + i + "]", file.name);
                        }
                    } else if (listFieldSubmit[field] == "fileCustomerName" || listFieldSubmit[field] == "fileCorpCustomerName") {
                        const indexHasFile = [];
                        const key = this.isCorporation ? 'CUSTOMER_CORP_NAME' : 'CUSTOMER_NAME'
                        const customerNameRef = this.getRefFromComponent(key);
                        for (let i = 1; i < 4; i++) {
                            if (customerNameRef[listFieldSubmit[field] + i] != null) {
                                indexHasFile.push(i);
                            }
                        }
                        for (let i = 0; i < indexHasFile.length; i++) {
                            const file = customerNameRef[listFieldSubmit[field] + indexHasFile[i]];
                            fd.append("fileCustomerNameUploades[" + i + "]", file);
                            fd.append("fileCustomerNameFileNames[" + i + "]", file.name);
                        }
                    }
                    if (listFieldSubmit[field] == "fileMnUpload") {
                        const indexHasFile = [];
                        const customerAddressRef = this.getRefFromComponent('MY_NUMBER_UPLOAD');
                        for (let i = 1; i < 3; i++) {
                            if (customerAddressRef[listFieldSubmit[field] + i] != null) {
                                indexHasFile.push(i);
                            }
                        }
                        for (let i = 0; i < indexHasFile.length; i++) {
                            const file = customerAddressRef[listFieldSubmit[field] + indexHasFile[i]];
                            fd.append("fileMnUploades[" + i + "]", file);
                            fd.append("fileMnUploadesFileNames[" + i + "]", file.name);
                        }
                    }
                } else {
                    let valueOfField = isNil(this.input["amsCustomerDetail." + listFieldSubmit[field]])
                        ? null
                        : this.input["amsCustomerDetail." + listFieldSubmit[field]];
                    if (listFieldSubmit[field] == "boLossMaxAmount") {
                        valueOfField = valueOfField.replace(/[^0-9]/g, '');
                    } else if (listFieldSubmit[field].indexOf('Password') != -1 && valueOfField == null) {
                        fd.append("amsCustomerDetail." + listFieldSubmit[field], '');
                    }
                    if (valueOfField != null) {
                        fd.append("amsCustomerDetail." + listFieldSubmit[field], valueOfField);
                    }
                }
            }
            for (let key in this.forceNewsInfo.mapUpdateBlock) {
                fd.append("mapUpdateBlock['" + key + "']", this.forceNewsInfo.mapUpdateBlock[key]);
            }
            fd.append('forceNewsId', this.forceNewsInfo.messageId);
            return fd;
        },
        validTotalBlocks(formData) {
            const currentPassword = formData.get('amsCustomerDetail.currentPassword');
            const newPassword = formData.get('amsCustomerDetail.newPassword');
            const reTypePassword = formData.get('amsCustomerDetail.reTypePassword');
            
            let result = true;
            const componentRefs = this.$refs;
            const componentRefsValue = Object.values(componentRefs)
            let status = [];
            for (const [key, value] of Object.entries(this.blocksInvalidStatus)) {
                if (this.forceNewsInfo.mapUpdateBlock[key]) {
                    status.push(value);
                }
            }
            status.every(status => (status !== null && status === false)) ? this.isValid = true : this.isValid = false;

            for (let i = 0; i < componentRefsValue.length; i++) {
                const item = componentRefsValue[i][0];
                const {$v} = item;
                $v.$touch();
                if ($v.$anyError) {
                    console.error("Block has error : " + item.$options.name);
                    if (item.$options.name === 'UpdatePwd' && _.isEmpty(currentPassword) && _.isEmpty(newPassword) && _.isEmpty(reTypePassword)) {
                        $v.input['amsCustomerDetail.currentPassword'].$reset();
                        $v.input['amsCustomerDetail.newPassword'].$reset();
                        $v.input['amsCustomerDetail.reTypePassword'].$reset();
                    }
                    
                    result = false;
                } else {
                    result = true;
                }
            }
            return result;
        },
        getRefFromComponent(key) {
            return this.$refs[this.forceNewsInfo.messageId + '_' + key][0];
        },
        scrollToCurrentNews(newsId) {
            const myDiv = $("#" + newsId);
            window.scrollTo(0, myDiv.offset().top);
        },
        handleChildFormStatus(isInvalid, blockName) {
            this.doesServerReturnError = false;
            this.blocksInvalidStatus[blockName] = isInvalid;
            if (this.blocksInvalidStatus[blockName]){
                this.statusBlock = true;
            }else {
                this.statusBlock = false;
            }
        },
        handleChangeFileUpload(blockName) {
            if (this.statusBlock) {
                this.blocksInvalidStatus[blockName] = true;
            }else {
                this.blocksInvalidStatus[blockName] = false;
            }
            this.doesServerReturnError = false;
        },
        disableAllInput() {
            let inputFields = $('#' + this.forceNewsInfo.messageId  + ' :input');
            inputFields.prop('disabled', true);
            inputFields.css("cursor", "not-allowed");
        }
    },
}
</script>

<style scoped>
button {
    margin-right: 4px;
}

.close {
    width: 10%;
}

.success-message {
    width: 90%;
}
</style>
